import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";

import i18nServerResponse from "../../constants/i18n-server-response";
import { TDataApproveRejectAction } from "../../Types";
import { post } from "../axios-post";

export const apiCallSolveApprovalData = async ({
  descriptionID,
  userUUID,
  action,
  from,
  imageID,
  resolvingPendindData
}: {
  descriptionID: number;
  adminUserId: number;
  userUUID: string;
  from: string;
  action: TDataApproveRejectAction;
  imageID: string;
  resolvingPendindData: boolean;
}): Promise<{
  data: number;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{ newUserId: number }>(
    `approveReject/solveApprovalData`,
    {
      userUUID,
      descriptionID,
      action,
      from,
      imageID,
      resolvingPendindData
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data.newUserId,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: 0,
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: 0,
      status: "ERROR",
      code: "ERROR"
    };
  }
};
